export default __webpack_public_path__ + "static/media/sass.7cdbf6b5.png";